export const getArrayFromN = (count: number): number[] => {
  return Array.from(Array(count).keys());
};
